import React, { PureComponent } from 'react'
import i18next from 'i18next'
import moment from 'moment'
import classnames from 'classnames'

import adminStyles from './styles/admin.scss'
import listingStyles from './styles/listing.scss'

export default class Wopi360RecipientsRow extends PureComponent {
  handleCopyTestLinkClick = e => {
    e.preventDefault()

    this.props.onCopyLinkClick(this.props.recipient)
  }

  handleDelete = e => {
    e.preventDefault()

    this.props.onDeleteClick(this.props.recipient)
  }

  sendReminderMail = async e => {
    e.preventDefault()

    const { uuid } = this.props.recipient
    this.props.onSendReminderClick([uuid])
  }

  renderTextCell = children =>
    this.props.recipient.isTarget ? <strong>{children}</strong> : children

  renderSendReminderLink = () => {
    const { isDeleted, isReminded, recipient: { finishedAt } } = this.props
    if (!!finishedAt || isDeleted) {
      return null
    }

    if (isReminded) {
      return (
        <span className={classnames(adminStyles.targetRecipientFinished)}>
          <strong>{i18next.t('sent')}</strong>
        </span>
      )
    }

    return (
      <a href="#" onClick={this.sendReminderMail}>
        {i18next.t('send')}
      </a>
    )
  }

  render() {
    const { recipient, isDeleted } = this.props

    return (
      <tr
        key={recipient.uuid}
        className={classnames({
          [adminStyles.targetRecipientFinished]: recipient.finishedAt,
          [listingStyles.deleted]: isDeleted
        })}
      >
        <td>{this.renderTextCell(`${recipient.email} (${recipient.defaultLanguage})`)}</td>

        <td>{this.renderTextCell(moment(recipient.createdAt).format('dd l'))}</td>

        <td>
          {this.renderTextCell(recipient.finishedAt && moment(recipient.finishedAt).format('dd l'))}
        </td>

        {recipient.isTarget && (
          <td>
            <strong>{i18next.t('target_person')}</strong>
          </td>
        )}

        {!recipient.isTarget && (
          <td>{recipient.role ? i18next.t(`role_${recipient.role}`) : ''}</td>
        )}

        {!isDeleted && (
          <td>
            <a href="#" onClick={this.handleCopyTestLinkClick}>
              {i18next.t('copy_test_link')}
            </a>
          </td>
        )}

        {isDeleted && <td>-</td>}

        <td style={{ width: 100 }}>
          {!recipient.isTarget &&
            !isDeleted && (
              <a href="#" onClick={this.handleDelete}>
                {i18next.t('delete')}
              </a>
            )}

          {!recipient.isTarget && isDeleted && <span>{i18next.t('deleted')}</span>}
        </td>

        <td>{this.renderSendReminderLink()}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360RecipientsRow.js